export const UPDATE_LIVROS_AUTOR = 'UDPATE_LIVROS_AUTOR'
export const ADD_LIVROS_AUTOR = 'ADD_LIVROS_AUTOR'
export const SET_LIVROS_AUTOR = 'SET_LIVROS_AUTOR'
export const REMOVE_LIVROS_AUTOR = 'REMOVE_LIVROS_AUTOR'
export const SET_LIVRO_AUTOR = 'SET_LIVRO_AUTOR'
export const OPEN_LIVRO_AUTOR = 'OPEN_LIVRO_AUTOR'
export const CLOSE_LIVRO_AUTOR = 'CLOSE_LIVRO_AUTOR'